import { TablePagination } from "@mui/material";
import { useState, useContext, useEffect } from "react";
import { VspPortalActions } from "../../store/VspPortalActions";
import VspPortalContext from "../../store/VspPortalContext";

type ArrivalLogsPaginationProps = {
    
    totalCount : number;

};

export const ArrivalLogsPagination: React.FC< ArrivalLogsPaginationProps > = ( props: ArrivalLogsPaginationProps ) => {

    const { totalCount } = props;

    const [ pageNumber, setPageNumber ] = useState< number >( 0 );
    const [ pageSize, setPageSize ] = useState( 20 );
  
    const { dispatch, state } = useContext( VspPortalContext );

    useEffect( ( ) => {

        setPageNumber( state.arrivalLogsPageNumber );
        setPageSize( state.arrivalLogsPageSize );

    }, [ ]);
    

    const handleChangePage = ( newPageNumber: number ): void => {

        setPageNumber( newPageNumber );
        dispatch({ type: VspPortalActions.SetArrivalLogsPageNumber, payload: newPageNumber });
        
    };
  

    const handleChangePageSize = ( event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement> ): void => {
   
        const newPageSize = +event.target.value; 
        setPageSize( newPageSize );
        setPageNumber( 0 );
        dispatch({ type: VspPortalActions.SetArrivalLogsPageSize, payload: newPageSize });
        dispatch({ type: VspPortalActions.SetArrivalLogsPageNumber, payload: 0 });

    };
   
    
    return(

        <TablePagination
            component="div"
            count={ totalCount }
            page={ pageNumber }
            onPageChange={ ( _, newPageNumber ) => handleChangePage( newPageNumber ) }
            rowsPerPage={ pageSize }
            onRowsPerPageChange={ handleChangePageSize }
            rowsPerPageOptions={ [ 20, 50, 100 ] }
        />

    );

};